import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import zhTW from './locales/zh-TW.json';
import fa from './locales/fa.json';
import hi from './locales/hi.json';
import it from './locales/it.json';
import mi from './locales/mi.json';
import ms from './locales/ms.json';
import ru from './locales/ru.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      pt: { translation: pt },
      zh: { translation: zh },
      'zh-TW': { translation: zhTW },
      fa: { translation: fa },
      hi: { translation: hi },
      it: { translation: it },
      mi: { translation: mi },
      ms: { translation: ms },
      ru: { translation: ru }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      // Owen Jul 2026 — added `querystring` FIRST so a share link like
      // `?lang=hi` overrides both localStorage and browser default.
      // When your friend shares the app while browsing in Hindi, the
      // URL carries `?lang=hi` and the recipient lands in Hindi
      // regardless of their own device locale. The choice is then
      // persisted to localStorage so they stay in that language on
      // subsequent visits (unless they pick a new one from the
      // switcher). Recognised param name is the standard `lang`.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage']
    }
  });

export default i18n;
